import React from 'react'
import { Layout, SectionTitle, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          title="Divider"
          text={
            <p>
              Dividers must use at least a{' '}
              <span class="inline__code">l-margin-vertical--medium</span> to
              keep 16px above and below them. The divider must span 100% width
              of the parent container.
            </p>
          }
          code={code.divider}
        >
          <hr class="c-divider" />
        </Showcase>
      </Layout>
    </>
  )
}
export const code = {
  divider: `<hr class="c-divider" />
`,
}
